import {Modal} from "antd"
import {Icon} from "components/Icon"
import styles from "./EventPopup.module.css"
import {SchoolClosureForm} from "./SchoolClosureForm"
import {DisplayMode} from "types/common"

type SchoolClosurePopupProps = {
    calendarId: number
    isShow: boolean
    onCreateSuccess: Function
    onClose: () => void
    displayMode?: DisplayMode
}

export const SchoolClosurePopup = (props: SchoolClosurePopupProps) => {
    const {isShow, onClose} = props

    return (
        <Modal
            keyboard={false}
            closable={false}
            visible={isShow}
            onCancel={onClose}
            closeIcon={<Icon icon="CLOSE" color="#000" className={styles.closeIcon} />}
            maskClosable={false}
            footer={null}
            className="eventPopup">
            <SchoolClosureForm {...props} />
        </Modal>
    )
}
